import template from './syncSettings.html';
import controller from './syncSettings.controller';

let syncSettingsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default syncSettingsComponent;



// WEBPACK FOOTER //
// ./app/components/syncSettings/syncSettings.component.js